<template>
  <div class="long-text flex justify-center align-center">
    <span ref="textDom" class="ellipsis2" v-html="text || '-'"></span>
    <el-button v-if="previewAlways || (text && isEllipsis)" type="text" plain @click="view" icon="el-icon-zoom-in"></el-button>
    <rich-preview ref="rich"></rich-preview>
    <DialogDetail ref="dialog"></DialogDetail>
  </div>
</template>

<script>
import RichPreview from '@/components/rich-preview'
import DialogDetail from '../../dialogList/components/DialogDetail.vue'

export default {
  name: 'LongText',
  props: ['text', 'previewAlways'],
  components: { RichPreview, DialogDetail },
  data() {
    return {
      isEllipsis: true
    }
  },
  watch: {
    text() {
      this.updatePreviewMore()
    }
  },
  mounted() {
    this.updatePreviewMore()
  },
  methods: {
    async updatePreviewMore() {
      await this.$nextTick()
      const textDom = this.$refs.textDom
      this.isEllipsis = textDom.scrollHeight > textDom.offsetHeight
    },
    view() {
      const { isDialogDetail, sessionId } = this.$attrs
      if (isDialogDetail) this.$refs.dialog.open({ id: sessionId })
      else this.$refs.rich.open(this.text)
    }
  }
}
</script>

<style lang="scss" scoped>
.long-text {
  &__detail {
    color: red;
  }
}
</style>